import React, { useState, useCallback, useMemo } from "react";
import SwiperCarsouel from "../componants/swipercarsouel/SwiperCarsouel";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as urls from "../utils/URLConst";
import makeRequest from "../utils/makeRequest";
import ClientcontactDtl from "../componants/profile/ClientcontactDtl";
import { NavLink, useNavigate } from "react-router-dom";
import toastNotify from "../utils/ToastNotify";
import { Button, Col, Row } from "react-bootstrap";
import TextField from "../componants/textField/TextField";
import { useDispatch } from "react-redux";
import { handleLoader } from "../redux/reducers/layout";
import ClientcontactDtlAddModal from "../componants/modal/profile/ClientcontactDtlAddModal";
import DeleteConfirmationModal from "../componants/modal/DeleteConfirmationModal";
import { BiHomeAlt, BiLeftArrowAlt, BiSlider } from "react-icons/bi";

const UserProfile = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [custUser, setCustUser] = useState([]);
  const [isAddCustUserMdl, setIsAddCustUserMdl] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isDeleteMdl, setDeleteMdl] = useState(false);

  const handleAddCustUserMdl = (data) => {
    setIsAddCustUserMdl(!isAddCustUserMdl);
    setEditData(data || null);
  }

  const handleDeleteMdl = (data) => {
    setDeleteMdl(!isDeleteMdl);
    setEditData(data || null);
  }

  const fetchProfileData = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const config = {};
      const result = await makeRequest("POST", urls.getUserProfile, "", config);
      if (result.STATUS === "0") {
        const response = result.RESPONSE[0];
        setData(response);
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, []);


  const fetchCustomersUsers = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getUserContactDtl, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setCustUser(response);
      } else {
        setCustUser([])
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])


  async function RowDelete() {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        TRAN_CD: editData.TRAN_CD,
        ACTION_FLAG: "D",
      };
      const result = await makeRequest(
        "POST",
        urls.setUserContactDtl,
        payload,
        config
      );
      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        fetchCustomersUsers();
        handleDeleteMdl();
      } else if (result.STATUS !== "0") {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function handleSubmit(val) {
    try {
      dispatch(handleLoader(true));
      const payload = {
        COMPANY_NM: val.companyNm,
        GST_NO: val.gstNo,
        CUSTOMER_NM: val.personName,
        CBS_VENDOR: val.cbsVendor,
        MOBILE1: val.mobileNo,
        MOBILE2: val.alternativeNo,
        EMAIL: val.emailId,
        ADDRESS1: val.address1,
        ADDRESS2: val.address2,
        COUNTRY_CD: val.country,
        STATE_CD: val.state,
        DISTRICT_CD: val.district,
        CITY_NM: val.cityName,
        PIN_CD: val.pincode,
        CATEGORY_CD: "12",
        NPCI_CD: "",
        REMARKS: "",
      };

      const config = {};
      await makeRequest("POST", urls.setUserProfile, payload, config).then(
        (result) => {
          if (result.STATUS === "0") {
            toastNotify(result.MESSAGE, "success");
          } else if (result.STATUS !== "0") {
            toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useMemo(() => {
    (async () => {
      await fetchProfileData();
      await fetchCustomersUsers();
    })();
  }, []);

  const initialVal = {
    companyNm: data.COMPANY_NM,
    gstNo: data.GST_NO,
    personName: data.PERSON_NM,
    cbsVendorName: data.CBS_VENDOR_NM,
    cbsVendor: data.CBS_VENDOR,
    mobileNo: data.MOBILE_NO1,
    alternativeNo: data.MOBILE_NO2,
    emailId: data.EMAIL_ID,
    address1: data.ADDRESS1,
    address2: data.ADDRESS2,
    country: data.COUNTRY_NAME,
    state: data.STATE_NAME,
    district: data.DISTRICT_NAME,
    cityName: data.CITY_NM,
    pincode: data.PIN_CODE,
  };


  const validationSchema = Yup.object().shape({
    companyNm: Yup.string().required("Company name is required"),
    gstNo: Yup.string().required("GST Number is required")
      .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST number").min(15, "GST Number must be at least 15 digits").max(15, "GST Number must not exceed 15 digits"),
    personName: Yup.string().required("Person Name is required"),
    mobileNo: Yup.string().required("Mobile No. is required").matches(/^[6-9][0-9]{9}$/, "Must have valid mobile no."),
    emailId: Yup.string().required("Email is required").matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Invalid email address"),
    address1: Yup.string().required("Address is required"),
    pincode: Yup.string().required("Pincode is required").min(6, "Pincode must be at least 6 digits"),
    cityName: Yup.string().required("City Name is required"),
    district: Yup.string().required("District is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
  });

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className=" date-time container-top">
          <div className="d-flex align-items-center">
            <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1"> Profile</span>
            </div>
            <Button
              type="button"
              variant="warning"
              className="btn-sm ms-auto"
              onClick={() => navigate("/dashboard")}
            >
              <BiLeftArrowAlt className="text-lg me-1" />
              Back
            </Button>
          </div>
        </div>

        <Row>
          <Col md={8}>
            <div className="nav-align-top mb-4">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link active"
                    role="tab"
                    data-bs-toggle="tab"
                    data-bs-target="#navs-top-home"
                    aria-controls="navs-top-home"
                    aria-selected="true"
                  >
                    Profile
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link"
                    role="tab"
                    data-bs-toggle="tab"
                    data-bs-target="#navs-top-profile"
                    aria-controls="navs-top-profile"
                    aria-selected="false"
                  >
                    Contact Detail
                  </button>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  className="tab-pane fade show active"
                  id="navs-top-home"
                  role="tabpanel"
                >
                  <div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialVal}
                      validationSchema={validationSchema}
                      onSubmit={(values) => handleSubmit(values)}
                    >
                      {({ values, handleChange, handleBlur, setFieldValue }) => (
                        <Form>
                          <Row>
                            <Col md={6}>
                              <TextField
                                label="Company Name"
                                name="companyNm"
                                id="companyNm"
                                required
                                tabIndex={1}
                                maxLength={50}
                                value={values.companyNm}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="companyNm" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-md-0 mt-4">
                              <TextField
                                label="GST No."
                                name="gstNo"
                                id="gstNo"
                                required
                                tabIndex={2}
                                maxLength={15}
                                value={values.gstNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  setFieldValue("gstNo", value.toUpperCase());
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="gstNo" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-4">
                              <TextField
                                label="Person Name"
                                name="personName"
                                id="personName"
                                required
                                tabIndex={3}
                                maxLength={30}
                                value={values.personName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="personName" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-4">
                              <TextField
                                label="CBS Vendor"
                                name="cbsVendorName"
                                id="cbsVendorName"
                                required
                                disabled
                                tabIndex={4}
                                maxLength={30}
                                value={values.cbsVendorName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="cbsVendorName" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="Mobile No."
                                name="mobileNo"
                                id="mobileNo"
                                required
                                tabIndex={5}
                                maxLength={10}
                                value={values.mobileNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  const regex = /^[0-9]*[.,]?[0-9]*$/;
                                  if (regex.test(value.toString())) {
                                    setFieldValue("mobileNo", value);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="mobileNo" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="Alternative No."
                                name="alternativeNo"
                                id="alternativeNo"
                                tabIndex={6}
                                maxLength={10}
                                value={values.alternativeNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  const regex = /^[0-9]*[.,]?[0-9]*$/;
                                  if (regex.test(value.toString())) {
                                    setFieldValue("alternativeNo", value);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="alternativeNo" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-4">
                              <TextField
                                label="Email Id"
                                type="email"
                                name="emailId"
                                id="emailId"
                                required
                                tabIndex={7}
                                maxLength={30}
                                value={values.emailId}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="emailId" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-4">
                              <TextField
                                label="Address 1"
                                name="address1"
                                id="address1"
                                required
                                tabIndex={8}
                                maxLength={50}
                                value={values.address1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="address1" className='error-msg' component="div" />
                            </Col>

                            <Col md={6} className="mt-4">
                              <TextField
                                label="Address 2"
                                name="address2"
                                id="address2"
                                tabIndex={9}
                                maxLength={50}
                                value={values.address2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="address2" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="Country"
                                name="country"
                                id="country"
                                required
                                tabIndex={10}
                                maxLength={30}
                                value={values.country}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="country" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="State"
                                name="state"
                                id="state"
                                required
                                tabIndex={11}
                                maxLength={30}
                                value={values.state}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="state" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="District"
                                name="district"
                                id="district"
                                required
                                tabIndex={12}
                                maxLength={30}
                                value={values.district}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="district" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="City"
                                name="cityName"
                                id="cityName"
                                required
                                tabIndex={13}
                                maxLength={30}
                                value={values.cityName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="cityName" className='error-msg' component="div" />
                            </Col>

                            <Col md={3} className="mt-4">
                              <TextField
                                label="Pincode"
                                name="pincode"
                                id="pincode"
                                required
                                tabIndex={14}
                                maxLength={6}
                                value={values.pincode}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;
                                  const regex = /^[0-9]*[.,]?[0-9]*$/;
                                  if (regex.test(value.toString())) {
                                    setFieldValue("pincode", value);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="pincode" className='error-msg' component="div" />
                            </Col>
                          </Row>

                          <div className="mt-4">
                            <Button
                              type="submit"
                              variant="primary"
                              className="btn-sm me-2"
                            >
                              Save change
                            </Button>
                            <Button
                              type="reset"
                              variant="secondary"
                              className="btn-sm"
                            >
                              Cancel
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                  {/* )} */}
                </div>
                <div
                  className="tab-pane fade"
                  id="navs-top-profile"
                  role="tabpanel"
                >
                  <ClientcontactDtl
                    data={custUser}
                    handleAddCustUserMdl={handleAddCustUserMdl}
                    handleDeleteMdl={handleDeleteMdl}
                  />
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="productrenewal"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            ></div>
          </Col>
          {/* ******************* Other Product and Services ******************* */}
          <div className="col-lg-4 col-md-6">
            <div className="pb-2">
              <BiSlider />{' '}
              <span className="fw-bold">Other Products &amp; Services</span>
            </div>
            <div
              className="card product_service"
              style={{
                padding: "20px 0px 20px 0px",
                height: "685px",
              }}
            >
              <div
                className="card-body py-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <SwiperCarsouel />
              </div>
            </div>
          </div>
        </Row>
      </div >

      {isAddCustUserMdl && (
        <ClientcontactDtlAddModal
          isOpen={isAddCustUserMdl}
          editData={editData}
          handleAddCustUserMdl={handleAddCustUserMdl}
          fetchCustomersUsers={fetchCustomersUsers}
        />
      )}


      {/* {clientContactDtlEditModal && (
        <ClientcontactDtlEditModal
          clientContactDtlEditModal={clientContactDtlEditModal}
          setClientContactDtlEditModal={setClientContactDtlEditModal}
          fetchClientContactDtl={fetchClientContactDtl}
          tranCodeData={tranCodeData}
          setTranCodeData={setTranCodeData}
          apidata={apidata}
        />
      )} */}

      {isDeleteMdl && (
        <DeleteConfirmationModal
          Title={"Delete Confirmation!"}
          Message={"Do you really want to delete this record ?"}
          deleteConfirmationModal={isDeleteMdl}
          setDeleteConfirmationModal={setDeleteMdl}
          deleteRow={() => {
            RowDelete();
          }}
        />
      )}
    </>
  );
};

export default UserProfile;
